import React, { useState, useEffect } from "react";
import  "./instantFaceSwap.scss";
import faceSwap01 from "@/../public/home/instantFaseSwap/faceSwap01.png";
import faceSwap02 from "@/../public/home/instantFaseSwap/faceSwap02.png";
import faceSwap03 from "@/../public/home/instantFaseSwap/faceSwap03.png";
import Image from "next/image";

export default function InstantFaceSwap() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      //console.log(activeIndex);
      setActiveIndex(prevIndex => (prevIndex + 1) % 3);
    }, 2000);
    return () => clearInterval(intervalId);
  }, [activeIndex]);

  return (
    <div className="InstantFaceSwap">
      <div className="leftContainer">
        <p className="aginoMoulFont title">
          Instant face swaps, <br /> endless possibilities!
        </p>
      </div>
      <div className="rightContainer">
        <div className="imgContainer01">
          <Image src={faceSwap01} alt="face-swap-01" />
        </div>
        <div className="imgContainer02">
          <Image src={faceSwap02} alt="face-swap-02" />
        </div>
        <div className="imgContainer03">
          <Image src={faceSwap03} alt="face-swap-03" />
        </div>
      </div>

      {/* mobile */}
      <div className="rightContainerMobile">
        <div
          className={`imgContainer01 ${
            activeIndex === 0 ? "show" : ""
          }`}
        >
          <Image src={faceSwap01} alt="face-swap-01" />
        </div>

        <div
          className={`imgContainer02 ${
            activeIndex === 1 ? "show" : ""
          }`}
        >
          <Image src={faceSwap02} alt="face-swap-02" />
        </div>

        <div
          className={`imgContainer03 ${
            activeIndex === 2 ? "show" : ""
          }`}
        >
          <Image src={faceSwap03} alt="face-swap-03" />
        </div>
      </div>
    </div>
  );
}
